import { useTheme } from '@mui/system';
import { BaseEdge, EdgeProps, getBezierPath } from 'reactflow';

import {
  DESELECTED_EDGE_STROKE_WIDTH,
  SELECTED_EDGE_STROKE_WIDTH,
} from '../constants';

export const DataEdge = (props: EdgeProps): JSX.Element => {
  const theme = useTheme();
  const { sourceX, sourceY, targetX, targetY, selected } = props;

  // TODO(AL, 14/10/2024): Lets get rid of these magic numbers
  const [edgePath] = getBezierPath({
    sourceX: 3.5 + sourceX,
    sourceY,
    targetX: 3 + targetX,
    targetY: 3.5 + targetY,
  });

  return (
    <BaseEdge
      path={edgePath}
      style={{
        stroke: theme.palette.common.black,
        strokeWidth: selected
          ? SELECTED_EDGE_STROKE_WIDTH
          : DESELECTED_EDGE_STROKE_WIDTH,
        strokeLinecap: 'round',
      }}
    />
  );
};
